import {
  ADD_SPECIALIST_FAILURE,
  ADD_SPECIALIST_REQUEST,
  ADD_SPECIALIST_SUCCESS,
  DELETE_SPECIALIST_FAILURE,
  DELETE_SPECIALIST_REQUEST,
  DELETE_SPECIALIST_SUCCESS,
  FETCH_LIST_SPECIALIST_FAILURE,
  FETCH_LIST_SPECIALIST_REQUEST,
  FETCH_LIST_SPECIALIST_SUCCESS,
  FETCH_SPECIALIST_FAILURE,
  FETCH_SPECIALIST_REQUEST,
  FETCH_SPECIALIST_SUCCESS,
  RESET_CURRENT_SPECIALIST,
  UPDATE_SPECIALIST_FAILURE,
  UPDATE_SPECIALIST_REQUEST,
  UPDATE_SPECIALIST_SUCCESS,
} from './specialistType';

export const fetchSpecialists = () => {
  return {
    type: FETCH_LIST_SPECIALIST_REQUEST,
  };
};

export const fetchSpecialistsSuccess = (specialists) => ({
  type: FETCH_LIST_SPECIALIST_SUCCESS,
  payload: { specialists },
});

export const fetchSpecialistsFailure = (error) => ({
  type: FETCH_LIST_SPECIALIST_FAILURE,
  payload: { error },
});

// View single specialist
export const fetchSpecialist = (specialistId) => ({
  type: FETCH_SPECIALIST_REQUEST,
  payload: { specialistId },
});

export const fetchSpecialistSuccess = (specialist) => ({
  type: FETCH_SPECIALIST_SUCCESS,
  payload: { specialist },
});

export const fetchSpecialistFailure = (error) => ({
  type: FETCH_SPECIALIST_FAILURE,
  payload: { error },
});

// Add specialist
export const addSpecialist = (specialistData) => ({
  type: ADD_SPECIALIST_REQUEST,
  payload: { specialistData },
});

export const addSpecialistSuccess = (specialist) => ({
  type: ADD_SPECIALIST_SUCCESS,
  payload: { specialist },
});

export const addSpecialistFailure = (error) => ({
  type: ADD_SPECIALIST_FAILURE,
  payload: { error },
});

// Edit specialist
export const updateSpecialist = (specialistId, specialistData) => ({
  type: UPDATE_SPECIALIST_REQUEST,
  payload: { specialistId, specialistData },
});

export const updateSpecialistSuccess = (specialist) => ({
  type: UPDATE_SPECIALIST_SUCCESS,
  payload: { specialist },
});

export const updateSpecialistFailure = (error) => ({
  type: UPDATE_SPECIALIST_FAILURE,
  payload: { error },
});

// Delete specialist
export const deleteSpecialist = (specialistId) => ({
  type: DELETE_SPECIALIST_REQUEST,
  payload: { specialistId },
});

export const deleteSpecialistSuccess = (specialistId) => ({
  type: DELETE_SPECIALIST_SUCCESS,
  payload: { specialistId },
});

export const deleteSpecialistFailure = (error) => ({
  type: DELETE_SPECIALIST_FAILURE,
  payload: { error },
});

// Reset current specialist
export const resetCurrentSpecialist = () => ({
  type: RESET_CURRENT_SPECIALIST,
});
